var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave01 = function SvgSave01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-01_svg2__a",
    x1: 13.9,
    x2: 177.86,
    y1: 180.36,
    y2: 27.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m198.07 41.93-40-40A6.7 6.7 0 0 0 153.33 0H20C8.95 0 0 8.95 0 20v160c0 11.05 8.95 20 20 20h160c11.05 0 20-8.95 20-20V46.67a6.68 6.68 0 0 0-1.93-4.73Zm-71.4-28.6v40H73.34v-40zm-80 173.34V140c0-3.68 2.98-6.67 6.67-6.67h93.33c3.68 0 6.67 2.98 6.67 6.67v46.67zm140-6.67c0 3.68-2.98 6.67-6.67 6.67h-13.33V140c0-11.05-8.95-20-20-20H53.33c-11.05 0-20 8.95-20 20v46.67H20c-3.68 0-6.67-2.98-6.67-6.67V20c0-3.68 2.98-6.67 6.67-6.67h40v40c0 7.36 5.97 13.33 13.33 13.33h53.33c7.36 0 13.33-5.97 13.33-13.33v-40h10.6l36.07 36.07V180Z",
    style: {
      fill: "url(#save-01_svg2__a)"
    }
  }));
};
export default SvgSave01;